var map = {
	"./ADD.png": "a7ef",
	"./DKS.png": "02e0",
	"./END.png": "a5b5",
	"./HOTKEY.png": "20b8",
	"./MPT.png": "fca9",
	"./MT.png": "344e",
	"./REST.png": "6532",
	"./RS.png": "ee1b",
	"./SOCD.png": "0b34",
	"./TGL.png": "79ca",
	"./auto.png": "8a23",
	"./folder.png": "623f",
	"./link.png": "98bc",
	"./macro.png": "f6a5",
	"./password.png": "6a2a",
	"./site.png": "bb37",
	"./txt.png": "b1be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7f3";